import {ApiClient} from '@adyenPWA/lib/services/api'
import {filterPaymentMethods} from './filterPaymentMethods'

export class AdyenPaymentMethodsService {
    baseUrl = '/api/adyen/paymentMethods'
    apiClient = null

    constructor(token, site) {
        this.apiClient = new ApiClient(this.baseUrl, token, site)
    }

    /**
     * Fetches available payment methods for a given customer and basket context.
     *
     * @param {string} customerId - The unique identifier for the customer.
     * @param {Object} locale - The locale object containing the language and region settings.
     * @param {string} billingCountryCode - The ISO 3166-1 alpha-2 code of the billing country.
     * @param {string} basketId - The unique identifier for the current basket.
     * @param {string} siteId - The identifier for the current site.
     * @param {boolean} [isExpress=false] - Flag indicating if the request is for an express checkout.
     * @param {Object} currentBasket - The current basket object containing the items and details.
     * @returns {Promise<Object>} A promise that resolves to the filtered payment methods available for the specified parameters.
     * @throws {Error} Throws an error if the API response status is 300 or higher.
     */
    async fetchPaymentMethods(
        customerId,
        locale,
        billingCountryCode,
        basketId,
        siteId,
        isExpress = false,
        currentBasket,
        shipToCountry
    ) {
        const options = {
            queryParams: {locale: locale.id, basketId, isExpress, shipToCountry},
            headers: {
                customerid: customerId
            }
        }
        if (billingCountryCode) {
            options.queryParams.billingCountryCode = billingCountryCode
        }
        const res = await this.apiClient.get(options)
        if (res.status >= 300) {
            throw new Error(res)
        } else {
            let result = await res.json()
            let paymentResult = await filterPaymentMethods(
                result,
                billingCountryCode,
                siteId,
                isExpress,
                currentBasket,
                shipToCountry
            )

            return paymentResult
        }
    }
}
